var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoShowPassWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0508 11.35C19.0508 10.35 19.7508 9.45 20.2508 8.75C20.5508 8.35 20.7508 8.15 20.7508 7.75C20.7508 7.35 20.5508 7.25 20.2508 6.75C18.8508 4.85 15.3508 0.75 10.7508 0.75C9.75078 0.75 8.85078 0.95 8.05078 1.25",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 10.8504C9.05 10.8504 7.75 9.55039 7.75 7.85039C7.75 7.05039 8.05 6.25039 8.65 5.75039L5.55 2.65039C3.55 4.05039 2.05 5.85039 1.25 6.95039C0.95 7.35039 0.75 7.55039 0.75 7.85039C0.75 8.15039 0.95 8.35039 1.25 8.85039C2.65 10.7504 6.15 14.8504 10.75 14.8504C12.75 14.8504 14.55 14.1504 15.95 13.0504L12.85 9.95039C12.35 10.5504 11.55 10.8504 10.75 10.8504Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 7.85C7.75 9.55 9.05 10.85 10.75 10.85C11.55 10.85 12.35 10.55 12.85 9.95L8.65 5.75C8.05 6.25 7.75 7.05 7.75 7.85Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShowPassWord);
export default __webpack_public_path__ + "static/media/NoShowPassWord.bb0da215a4f2ad7541fc68e692d0d31c.svg";
export { ForwardRef as ReactComponent };